import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { getFormComponentStyle } from './getFormComponentStyle'

export const Textarea: ComponentStyleConfig = {
  variants: {
    default: (props: Dict) => ({
      ...getFormComponentStyle(props),
    }),
  },
  defaultProps: {
    variant: 'default',
  },
}
